import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=28594b54"
import script from "./UserCreateForm.vue?vue&type=script&lang=js"
export * from "./UserCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28594b54')) {
      api.createRecord('28594b54', component.options)
    } else {
      api.reload('28594b54', component.options)
    }
    module.hot.accept("./UserCreateForm.vue?vue&type=template&id=28594b54", function () {
      api.rerender('28594b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/User/UserCreateForm.vue"
export default component.exports